import { clearFetch } from './Utils';

const isBrowserInner = new Function('try {return this===window;}catch(e){ return false;}');
let _isBrowser = undefined;

export function isBrowser() {
  if (_isBrowser === undefined) {
    _isBrowser = isBrowserInner();
    console.log('isBrowser=' + _isBrowser);
  }
  return _isBrowser;
}

function hrefToUrl() {
  let serverUrl = window.location.href;

  //guard against funkiness like chrome auto-tacking things onto the url (I've seen this)
  const slashes = '://';
  let idx = serverUrl.indexOf(slashes);
  if (idx >= 0) {
    idx = serverUrl.indexOf('/', idx + slashes.length);
    if (idx >= 0) serverUrl = serverUrl.slice(0, idx);
  }

  if (!serverUrl.endsWith('/')) serverUrl += '/';

  return serverUrl;
}

export async function fetchConf({ success, bad, badJson }) {
  if (!success || !bad) throw new Error('fetchConf: success and bad procs are required');

  let options = {
    method: 'GET',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  };

  let resultJson, resultLogStr;
  await clearFetch(`${hrefToUrl()}version.js`, options, {
    success: (json) => (resultJson = json),
    bad: ({ logStr }) => (resultLogStr = logStr),
    badJson,
  });

  if (resultJson) {
    console.log('fetchConf loaded: ' + JSON.stringify(resultJson));
    success(resultJson);
  }
  else if (resultLogStr) {
    bad(resultLogStr);
  }
}
